import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import { emptyCellOneLevel, formatCurrency } from '@/shared';
import { SampleTable, TabTextLabel } from '@/shared/components/ui';
import { Contrato } from '@/shared/interfaces';
import { Grid } from '@mui/material';
import ContractStateChip from '../../ContractStateChip';

export type ClienteFibraServicePlanTableProps = {
  contract: Contrato;
};

type ServicePlanType = {
  id_cliente?: string;
  numero_contrato: string; // contrato
  tipo_contrato: string; // ?
  tipo_servicio: string;
  plan_contratado: string;
  costo_plan: string; // precio base del plan
  ip_asignada: string;
  router: string;
  direccion: string;

  username: string; // ppoe/userftth - activacion
  password: string; // password - activacion

  estado_servicio: string; // code - estado contrato
  estado_equipo: string; // cliente

  url_contrato?: string;
};

const ClienteFibraServicePlanTable: React.FC<
  ClienteFibraServicePlanTableProps
> = ({ contract }) => {
  const data: ServicePlanType[] = [
    {
      id_cliente: contract?.cliente_data?.id_cliente,
      numero_contrato: contract?.numero_referencia!,
      tipo_contrato: contract?.tipo_plan, // tipo_plan
      tipo_servicio: contract?.tipo_servicio,
      plan_contratado: contract?.plan_data?.nombre!,
      costo_plan: contract?.valor_plan!,
      router: contract?.router_data?.nombre!,
      direccion: contract?.direccion, // del cliente
      ip_asignada: contract?.ipv4_actual!, // grupo IPv4

      username: contract?.pppoe!,
      password: contract?.pppassword!,
      estado_servicio: contract?.estado_contrato,

      estado_equipo: contract?.estado_equipo,

      url_contrato: contract?.url_contrato,
    },
  ];

  ///* columns
  const columns = useMemo<MRT_ColumnDef<ServicePlanType>[]>(
    () => [
      {
        accessorKey: 'id_cliente',
        header: 'ID Cliente',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'id_cliente'),
      },
      {
        accessorKey: 'numero_contrato',
        header: 'Número de Contrato',
        size: 180,
        Cell: ({ row }) => {
          return row.original?.numero_contrato ? (
            <div
              onClick={() => {
                // target blank a una url de contrato:
                window.open(row.original?.url_contrato, '_blank');
              }}
              style={{
                cursor: 'pointer',
                color: 'inherit',
                textDecoration: 'underline',
              }}
            >
              {row.original?.numero_contrato}
            </div>
          ) : (
            'N/A'
          );
        },
      },
      {
        accessorKey: 'tipo_contrato',
        header: 'Tipo de Contrato',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'tipo_contrato'),
      },
      {
        accessorKey: 'tipo_servicio',
        header: 'Tipo de Servicio',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'tipo_servicio'),
      },
      {
        accessorKey: 'plan_contratado',
        header: 'Plan Contratado',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'plan_contratado'),
      },
      {
        accessorKey: 'costo_plan',
        header: 'Costo del Plan',
        size: 180,
        Cell: ({ row }) => {
          return row.original?.costo_plan
            ? formatCurrency(row.original?.costo_plan)
            : 'N/A';
        },
      },
      {
        accessorKey: 'ip_asignada',
        header: 'IP Asignada',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'ip_asignada'),
      },
      {
        accessorKey: 'router',
        header: 'Router',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'router'),
      },
      {
        accessorKey: 'direccion',
        header: 'Dirección',
        size: 234,
        Cell: ({ row }) => emptyCellOneLevel(row, 'direccion'),
      },
      {
        accessorKey: 'username',
        header: 'Username',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'username'),
      },
      {
        accessorKey: 'password',
        header: 'Password',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'password'),
      },
      {
        accessorKey: 'estado_servicio',
        header: 'Estado del Servicio',
        size: 180,

        Cell: () => <ContractStateChip contract={contract!} />,
      },
      {
        accessorKey: 'estado_equipo',
        header: 'Estado del Equipo',
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, 'estado_equipo'),
      },
    ],
    []
  );

  return (
    <Grid
      item
      xs={12}
      sx={{
        pb: 4,
      }}
    >
      <TabTextLabel text="Servicio de Internet" pl={0} />

      {/* ----- table ----- */}
      <SampleTable<ServicePlanType>
        data={data}
        columns={columns}
        enablePagination
      />
    </Grid>
  );
};

export default ClienteFibraServicePlanTable;
